<!-- TelaMenuPrincipal.svelte -->
<script>
  import { navigate } from "svelte-routing";
    import Constantes from "../../Classes/Constantes";
  
</script>

<style>
  /* Estilo para a imagem de fundo */
  .background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url('/img/backmenu.jpg');
    background-size: cover; /* Para cobrir toda a tela */
    background-position: center; /* Para centralizar a imagem */
  }

  .card {
    width: 100%;
    max-width: 900px;
    margin: 50px auto;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    background-color: rgba(255, 255, 255, 0.3); /* Adicionando fundo branco transparente para destacar o conteúdo */
  }

  .grid-container {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
    gap: 10px;
  }

  .menu-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px;
    border: 1px solid #ccc; /* Adiciona uma borda */
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0.7);
    transition: background-color 0.3s ease;
    color: white;
    cursor: pointer;
    height: 100px; /* Altura fixa para os botões */
    text-align: center;
  }

  .menu-item:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }

  .icon {
    margin-bottom: 10px;
    font-size: 24px; /* Tamanho do ícone */
  }

  .sem-borda {
    border: 0px solid #ccc; /* Remove a borda */
    border-radius: 0px;
  }

</style>

<div class="background">
  <div class="card">
  

    <div class="grid-container">
      <div class="menu-item" on:click={() => navigate(Constantes.tela_exibir_camisas)}>
        <span class="icon fa fa-tshirt"></span>
        <span>Cadastro de camisas</span>
      </div>
      <div class="menu-item" on:click={() => navigate(Constantes.tela_cupons)}>
        <span class="icon fa fa-ticket-alt"></span>
        <span>Cupons</span>
      </div>
      <div class="menu-item" on:click={() => navigate(Constantes.tela_montar_campeonatos)}>
        <span class="fa fa-calendar-alt"></span>
        <span>Montar campeonatos</span>
      </div>
      <div class="menu-item" on:click={() => navigate(Constantes.tela_inscritos)}>
        <span class="icon fa fa-clipboard-list"></span>
        <span>Inscritos não pagos</span> 
      </div>
      
    </div>
  </div>
</div>
